/**
 * Typiq — l'accueil, dossier final (« Typiq Home v8 »), sections/tq-home.liquid.
 *
 * La rotation à 360° (un tour, rebouclé sans couture) et son compteur de
 * degrés calé sur currentTime ; le comparateur avant / après ; la rangée d'avis
 * (flèches au bureau) ; l'apparition des sections ; le bouton « horizon »
 * quand « Découvrir » sort par le haut ; le menu plein écran du téléphone
 * et les liens d'ancre de l'en-tête.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-tq-home]');
  if (!root) { return; }
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NAR = window.matchMedia ? window.matchMedia('(max-width: 759px)') : { matches: true };
  var track = window.tqTrack || function () {};

  function each(sel, fn, scope) { var list = (scope || root).querySelectorAll(sel); for (var i = 0; i < list.length; i++) { fn(list[i], i); } }
  function scrollToSel(sel) {
    var t = document.querySelector(sel);
    if (!t) { return; }
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: RM ? 'auto' : 'smooth' });
  }

  /* ── La rotation à 360° ─────────────────────────────────────────── */

  var video = root.querySelector('[data-tq-spin]');
  var deg = root.querySelector('[data-tq-deg]');
  if (video) {
    var TURN = 5;
    var TYPE = 'video/mp4; codecs="avc1.64002a"';
    var src = video.getAttribute(NAR.matches ? 'data-src-m' : 'data-src-d');
    var mse = video.getAttribute(NAR.matches ? 'data-mse-m' : 'data-mse-d');
    var onScreen = false;
    var play = function () { var q = video.play(); if (q && q['catch']) { q['catch'](function () {}); } };
    var native = function () {
      video.loop = true;
      video.setAttribute('loop', '');
      video.src = src;
    };
    var MS = window.ManagedMediaSource || (!/Apple/.test(navigator.vendor || '') && window.MediaSource);
    var seamless = function () {
      var ms = new MS();
      var sb = null;
      var data = null;
      var end = 0;
      var trimmed = 0;
      var q = [];
      var dead = false;
      var fail = function () {
        if (dead) { return; }
        dead = true;
        native();
        if (onScreen) { play(); }
      };
      var pump = function () {
        if (dead || !sb || sb.updating || !q.length) { return; }
        try { q.shift()(); } catch (e) { fail(); }
      };
      var add = function () {
        var at = end;
        end += TURN;
        q.push(function () { sb.timestampOffset = at; sb.appendBuffer(data); });
        pump();
      };
      video.loop = false;
      video.removeAttribute('loop');
      video.disableRemotePlayback = true;
      video.src = URL.createObjectURL(ms);
      ms.addEventListener('sourceopen', function () {
        try { sb = ms.addSourceBuffer(TYPE); } catch (e) { fail(); return; }
        sb.addEventListener('updateend', pump);
        sb.addEventListener('error', fail);
        fetch(mse).then(function (r) {
          if (!r.ok) { throw new Error(String(r.status)); }
          return r.arrayBuffer();
        }).then(function (buf) { data = buf; add(); add(); }, fail);
      }, { once: true });
      video.addEventListener('error', fail);
      video.addEventListener('timeupdate', function () {
        if (dead || !data) { return; }
        if (video.currentTime > end - TURN) { add(); }
        var cut = Math.floor((video.currentTime - 1) / TURN) * TURN;
        if (cut > trimmed) {
          trimmed = cut;
          q.push(function () { sb.remove(0, cut); });
          pump();
        }
      });
    };
    var lastDeg = -1;
    var tick = function () {
      if (deg) {
        var d = Math.floor(((video.currentTime % TURN) / TURN) * 360) % 360;
        if (d !== lastDeg) { lastDeg = d; deg.textContent = (d < 10 ? '00' : d < 100 ? '0' : '') + d + '°'; }
      }
      if (onScreen) { window.requestAnimationFrame(tick); }
    };
    video.muted = true;
    video.defaultMuted = true;

    if (RM) {
      video.removeAttribute('autoplay');
      native();
      video.loop = false;
      video.addEventListener('loadeddata', function () { video.pause(); video.currentTime = 0; }, { once: true });
    } else {
      var streaming = !!(mse && MS && MS.isTypeSupported(TYPE));
      if (streaming) { seamless(); } else { native(); }
      var go = function () {
        if (onScreen) { return; }
        onScreen = true;
        play();
        window.requestAnimationFrame(tick);
        /*
         * Filet : si la rotation n'a pas démarré 2,5 s après son apparition
         * (lecture enchaînée refusée par un iPhone), retour au fichier simple
         * en boucle, qui démarre partout.
         */
        window.setTimeout(function () {
          if (!onScreen || !video.paused || !streaming) { return; }
          streaming = false;
          native();
          play();
        }, 2500);
      };
      /* iPhone en mode économie d'énergie : pas de lecture automatique ; elle part au premier toucher ou défilement. */
      var nudge = function () {
        if (!onScreen || !video.paused) { return; }
        play();
      };
      ['touchstart', 'scroll', 'pointerdown'].forEach(function (t) { window.addEventListener(t, nudge, { passive: true }); });
      video.addEventListener('canplay', function () { if (onScreen && video.paused) { play(); } });
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { go(); } else { onScreen = false; video.pause(); }
        }, { threshold: 0 }).observe(video.parentNode);
      } else {
        go();
      }
    }
  }

  /*
   * Les images sous le premier écran (avant / après, étapes, sélection)
   * ne partent qu'à 400 px de l'écran : chargées d'office, ~250 Ko se
   * disputaient la bande passante avec la rotation du premier écran.
   */
  var lz = root.querySelectorAll('img[data-tq-lz]');
  var lzLoad = function (im) { if (!im.getAttribute('src')) { im.src = im.getAttribute('data-tq-lz'); } };
  if (window.IntersectionObserver) {
    /* On observe la section (un carrousel horizontal masque ses cartes à l'observateur) ; une image d'un panneau masqué attend d'être montrée. */
    var lzo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        lzo.unobserve(e.target);
        if (e.target.tagName === 'IMG') { lzLoad(e.target); return; }
        var ims = e.target.querySelectorAll('img[data-tq-lz]');
        for (var k = 0; k < ims.length; k++) { if (ims[k].closest('[hidden]')) { lzo.observe(ims[k]); } else { lzLoad(ims[k]); } }
      });
    }, { rootMargin: '400px 0px 400px 0px' });
    var lzSecs = [];
    for (var li = 0; li < lz.length; li++) { var sec = lz[li].closest('section') || lz[li]; if (lzSecs.indexOf(sec) === -1) { lzSecs.push(sec); lzo.observe(sec); } }
  } else {
    for (var lj = 0; lj < lz.length; lj++) { lzLoad(lz[lj]); }
  }

  /* ── Avant, après ───────────────────────────────────────────────── */

  /* Toute l'image se saisit : le curseur natif invisible ne se prenait que par son pouce (≈ 28 px sur iPhone). Un glissé horizontal n'importe où suit le doigt, un toucher place la ligne ; un glissé vertical reste un défilement de page (touch-action: pan-y, le navigateur annule alors le geste). */
  var baGrab = function (circle, range) {
    var id = null;
    var moved = false;
    var x0 = 0;
    var y0 = 0;
    var set = function (e) {
      var r = circle.getBoundingClientRect();
      if (!r.width) { return; }
      range.value = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
      range.dispatchEvent(new Event('input'));
    };
    circle.addEventListener('pointerdown', function (e) {
      if (e.button > 0) { return; }
      id = e.pointerId;
      moved = false;
      x0 = e.clientX;
      y0 = e.clientY;
      if (e.pointerType === 'mouse') { e.preventDefault(); set(e); }
      try { circle.setPointerCapture(id); } catch (err) {}
    });
    /* Le geste se décide aux 6 premiers pixels : vertical, c'est la page qui défile et la ligne ne bouge pas. */
    circle.addEventListener('pointermove', function (e) {
      if (e.pointerId !== id) { return; }
      if (!moved && e.pointerType !== 'mouse') {
        var dx = Math.abs(e.clientX - x0);
        var dy = Math.abs(e.clientY - y0);
        if (dx < 6 && dy < 6) { return; }
        if (dy > dx) { id = null; return; }
      }
      moved = true;
      set(e);
    });
    circle.addEventListener('pointerup', function (e) { if (e.pointerId === id) { if (!moved) { set(e); } id = null; } });
    circle.addEventListener('pointercancel', function () { id = null; });
    /* Safari ne livre pas toujours le pointerup d'un toucher bref : le click, lui, arrive toujours. */
    circle.addEventListener('click', function (e) { if (!moved) { set(e); } });
  };

  var circle = root.querySelector('.tq-h-ba__circle');
  var range = root.querySelector('[data-tq-ba-range]');
  var zone = 0;
  var dragged = {};
  root.addEventListener('click', function (e) {
    var z = e.target.closest('[data-tq-zone]');
    if (z) {
      zone = parseInt(z.getAttribute('data-tq-zone'), 10);
      each('[data-tq-zone]', function (b) {
        var on = parseInt(b.getAttribute('data-tq-zone'), 10) === zone;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      each('[data-tq-zone-pane]', function (pane) { pane.hidden = parseInt(pane.getAttribute('data-tq-zone-pane'), 10) !== zone; });
      if (range) { range.value = 50; }
      if (circle) { circle.style.setProperty('--pos', '50%'); }
      return;
    }
    var s = e.target.closest('[data-tq-scroll]');
    if (s) { e.preventDefault(); scrollToSel(s.getAttribute('data-tq-scroll')); return; }
    var a = e.target.closest('[data-tq-rv]');
    if (a) { rvBy(parseInt(a.getAttribute('data-tq-rv'), 10)); }
  });
  if (range && circle) {
    range.addEventListener('input', function () {
      circle.style.setProperty('--pos', range.value + '%');
      if (!dragged[zone]) { dragged[zone] = true; track('before_after_drag', { zone: zone, page: 'accueil' }); }
    });
    if (window.PointerEvent) { baGrab(circle, range); }
  }

  /* ── Avis : trois cartes à la fois au bureau, une au téléphone ──── */

  var rail = root.querySelector('[data-tq-rv-rail]');
  function rvBy(d) {
    if (!rail) { return; }
    var c = rail.children[0];
    var step = c ? c.offsetWidth + 16 : 320;
    rail.scrollBy({ left: d * step * (NAR.matches ? 1 : 3), behavior: RM ? 'auto' : 'smooth' });
  }

  /* ── Les sections apparaissent en montant ───────────────────────── */

  if (!RM && window.IntersectionObserver) {
    var vh = window.innerHeight;
    var rv = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-shown'); e.target.classList.remove('is-hidden'); rv.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    each('[data-rv]', function (el) {
      if (el.getBoundingClientRect().top > vh * 0.9) { el.classList.add('is-hidden'); rv.observe(el); }
    });
  }

  /* ── Le bouton « horizon » ──────────────────────────────────────── */

  var cta = root.querySelector('[data-tq-hero-cta]');
  var hz = root.querySelector('[data-tq-hz]');
  if (cta && hz && window.IntersectionObserver) {
    new IntersectionObserver(function (es) {
      var e = es[0];
      var off = !e.isIntersecting && e.boundingClientRect.top < 10;
      root.setAttribute('data-arc', off ? '1' : '0');
      hz.tabIndex = off ? 0 : -1;
      hz.setAttribute('aria-hidden', off ? 'false' : 'true');
    }, { threshold: 0 }).observe(cta);
    hz.addEventListener('mouseenter', function () { hz.classList.add('is-hover'); });
    hz.addEventListener('mouseleave', function () { hz.classList.remove('is-hover'); });
  }

  /* ── En-tête : ancres, retour en haut, menu du téléphone ────────── */

  var menu = document.querySelector('[data-tq-menu]');
  var opener = document.querySelector('[data-tq-menu-open]');
  function setMenu(open) {
    if (!menu) { return; }
    menu.hidden = !open;
    document.documentElement.classList.toggle('tq-menu-open', open);
    if (opener) { opener.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    if (open) { var c = menu.querySelector('[data-tq-menu-close]'); if (c) { c.focus({ preventScroll: true }); } } else if (opener) { opener.focus({ preventScroll: true }); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tq-menu-open]')) { setMenu(true); return; }
    var link = e.target.closest('.tq-header [data-tq-scroll], [data-tq-menu] [data-tq-scroll]');
    if (link) {
      e.preventDefault();
      if (menu && !menu.hidden) { setMenu(false); }
      scrollToSel(link.getAttribute('data-tq-scroll'));
      return;
    }
    if (e.target.closest('[data-tq-menu-close]')) { setMenu(false); return; }
    var top = e.target.closest('.tq-header--home .tq-header__logo');
    if (top) { e.preventDefault(); if (menu && !menu.hidden) { setMenu(false); } window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu && !menu.hidden) { setMenu(false); } });
  if (NAR.addEventListener) { NAR.addEventListener('change', function (m) { if (!m.matches && menu && !menu.hidden) { setMenu(false); } }); }
})();
